import {PAYMENT_METHODS} from 'src/data/enums/paymentMethods';

export const paymentMethodOptions = Object.keys(PAYMENT_METHODS).map((method) => ({
    value: method,
    label: method,
}));
